import React from "react";
import {Check} from "@sparkware/app-utils";
import {PlayersLikeYouComponent} from "../../../../../components/players-like-you/players-like-you.component";
import {ApiListBaseModel} from "../api-list-base.model";
import {
    TrendingRecommendationTypeEnum
} from "../../../../ai-recommendations-reader/ai-recommendations-reader.service.interface";

const NUMBER_OF_TRENDING_RECOMMENDATIONS = 10;

export class PlayersLikeYouListModel extends ApiListBaseModel {

    protected _shouldBeDisplayed(): boolean {
        if(Check.isNullOrUndefined(this._computeGameTypes())) {
            return super._shouldBeDisplayed();
        }

        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    get listTypeId(): number {
        if(Check.isNullOrUndefined(this.services.abTestingFeatureDataProvider.playersLikeYouGamesListTypeId)) {
            return TrendingRecommendationTypeEnum.ActiveUsers;
        }

        return parseInt(this.services.abTestingFeatureDataProvider.playersLikeYouGamesListTypeId);
    }

    protected _getTitleTranslationParams() {
        let topCount = NUMBER_OF_TRENDING_RECOMMENDATIONS;

        if(0 < this.gameTypes.length && this.gameTypes.length < topCount) {
            topCount = this.gameTypes.length;
        }

        return {
            topNumber: topCount,
            countryName: this.services.user.countryName || this.services.translation.translate("YOUR_COUNTRY")
        }
    }

    protected _getGameTypes(): number[] {
        return this._computeGameTypes() || [];
    }

    protected get _useSquareIcons(): boolean {
        return true;
    }

    private _computeGameTypes(): number[] | null {
        if(this.listTypeId === TrendingRecommendationTypeEnum.ActiveUsers) {
            return this.services.aiEngine.trendingRecommendedGamesForPlayerByActiveUsers;
        } else {
            return this.services.aiEngine.trendingRecommendedGamesForPlayerByBets
        }
    }

    get maxGamesToShowInList(): number {
        return NUMBER_OF_TRENDING_RECOMMENDATIONS;
    }

    _renderList(listPosition: number): React.ReactElement | null {
        return (
            <PlayersLikeYouComponent key={this.listKey} viewModel={this} listPosition={listPosition}/>
        );
    }
}